import omit from 'lodash-es/omit'

import { useContentOverflow } from '../../../../../../hooks'
import { Avatar, AVATAR_HEIGHT_24 } from '../../../../../Avatar'
import { FloatingTooltip } from '../../../../../Floating'
import { MultiValuedListMoreItem } from '../../../../../MultiValuedList'

import * as styles from './MoreItem.module.css'

function MoreItem({ Icon, avatar, id, title, onClick, ...props }) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  const itemProps = omit(props, ['hoverable', 'to'])

  function handleClick() {
    onClick?.(id)
  }

  return (
    <MultiValuedListMoreItem
      {...itemProps}
      className={styles.moreItem}
      onClick={handleClick}
    >
      <div className={styles.item}>
        <Avatar Icon={Icon} size={AVATAR_HEIGHT_24} src={avatar} />
        <div className={styles.info}>
          <FloatingTooltip content={title} disabled={!overflow}>
            <span className={styles.text} ref={setContentOverflowRef}>
              {title}
            </span>
          </FloatingTooltip>
        </div>
      </div>
    </MultiValuedListMoreItem>
  )
}

export default MoreItem
